import * as React from 'react';
var RangeContext = /*#__PURE__*/React.createContext({});
export default RangeContext;